import { ImageMap } from '../contracts';

import file1, { ReactComponent as JSX1 } from './public/pm/1.svg';
import file2, { ReactComponent as JSX2 } from './public/pm/2.svg';
import file3, { ReactComponent as JSX3 } from './public/pm/3.svg';
import file4, { ReactComponent as JSX4 } from './public/pm/4.svg';
import file5, { ReactComponent as JSX5 } from './public/pm/5.svg';
import file6, { ReactComponent as JSX6 } from './public/pm/6.svg';
import file7, { ReactComponent as JSX7 } from './public/pm/7.svg';
import file8, { ReactComponent as JSX8 } from './public/pm/8.svg';
import file9, { ReactComponent as JSX9 } from './public/pm/9.svg';
import file10, { ReactComponent as JSX10 } from './public/pm/10.svg';
import file11, { ReactComponent as JSX11 } from './public/pm/11.svg';
import file12, { ReactComponent as JSX12 } from './public/pm/12.svg';
import file13, { ReactComponent as JSX13 } from './public/pm/13.svg';
import file14, { ReactComponent as JSX14 } from './public/pm/14.svg';
import file15, { ReactComponent as JSX15 } from './public/pm/15.svg';
import file16, { ReactComponent as JSX16 } from './public/pm/16.svg';
import file17, { ReactComponent as JSX17 } from './public/pm/17.svg';
import file18, { ReactComponent as JSX18 } from './public/pm/18.svg';
import file19, { ReactComponent as JSX19 } from './public/pm/19.svg';
import file20, { ReactComponent as JSX20 } from './public/pm/20.svg';
import file21, { ReactComponent as JSX21 } from './public/pm/21.svg';
import file22, { ReactComponent as JSX22 } from './public/pm/22.svg';
import file23, { ReactComponent as JSX23 } from './public/pm/23.svg';
import file24, { ReactComponent as JSX24 } from './public/pm/24.svg';
import file25, { ReactComponent as JSX25 } from './public/pm/25.svg';
import file26, { ReactComponent as JSX26 } from './public/pm/26.svg';
import file27, { ReactComponent as JSX27 } from './public/pm/27.svg';
import file28, { ReactComponent as JSX28 } from './public/pm/28.svg';
import file29, { ReactComponent as JSX29 } from './public/pm/29.svg';
import file30, { ReactComponent as JSX30 } from './public/pm/30.svg';
import file31, { ReactComponent as JSX31 } from './public/pm/31.svg';
import file32, { ReactComponent as JSX32 } from './public/pm/32.svg';
import file33, { ReactComponent as JSX33 } from './public/pm/33.svg';
import file34, { ReactComponent as JSX34 } from './public/pm/34.svg';
import file35, { ReactComponent as JSX35 } from './public/pm/35.svg';
import file37, { ReactComponent as JSX37 } from './public/pm/37.svg';
import file38, { ReactComponent as JSX38 } from './public/pm/38.svg';
import file39, { ReactComponent as JSX39 } from './public/pm/39.svg';
import file40, { ReactComponent as JSX40 } from './public/pm/40.svg';
import file41, { ReactComponent as JSX41 } from './public/pm/41.svg';
import file42, { ReactComponent as JSX42 } from './public/pm/42.svg';
import file43, { ReactComponent as JSX43 } from './public/pm/43.svg';
import file44, { ReactComponent as JSX44 } from './public/pm/44.svg';
import file45, { ReactComponent as JSX45 } from './public/pm/45.svg';
import file46, { ReactComponent as JSX46 } from './public/pm/46.svg';
import file47, { ReactComponent as JSX47 } from './public/pm/47.svg';
import file48, { ReactComponent as JSX48 } from './public/pm/48.svg';
import file49, { ReactComponent as JSX49 } from './public/pm/49.svg';
import file50, { ReactComponent as JSX50 } from './public/pm/50.svg';
import file51, { ReactComponent as JSX51 } from './public/pm/51.svg';
import file52, { ReactComponent as JSX52 } from './public/pm/52.svg';
import file53, { ReactComponent as JSX53 } from './public/pm/53.svg';
import file54, { ReactComponent as JSX54 } from './public/pm/54.svg';
import file88, { ReactComponent as JSX88 } from './public/pm/88.svg';
import file89, { ReactComponent as JSX89 } from './public/pm/89.svg';
import file90, { ReactComponent as JSX90 } from './public/pm/90.svg';
import file91, { ReactComponent as JSX91 } from './public/pm/91.svg';
import file92, { ReactComponent as JSX92 } from './public/pm/92.svg';
import file93, { ReactComponent as JSX93 } from './public/pm/93.svg';
import file94, { ReactComponent as JSX94 } from './public/pm/94.svg';
import file95, { ReactComponent as JSX95 } from './public/pm/95.svg';
import file101, { ReactComponent as JSX101 } from './public/pm/101.svg';
import file102, { ReactComponent as JSX102 } from './public/pm/102.svg';
import file103, { ReactComponent as JSX103 } from './public/pm/103.svg';
import file106, { ReactComponent as JSX106 } from './public/pm/106.svg';
import file107, { ReactComponent as JSX107 } from './public/pm/107.svg';
import file104, { ReactComponent as JSX104 } from './public/pm/104.svg';
import file96, { ReactComponent as JSX96 } from './public/pm/96.svg';
import file97, { ReactComponent as JSX97 } from './public/pm/97.svg';
import file98, { ReactComponent as JSX98 } from './public/pm/98.svg';
import file99, { ReactComponent as JSX99 } from './public/pm/99.svg';
import file100, { ReactComponent as JSX100 } from './public/pm/100.svg';
import file108, { ReactComponent as JSX108 } from './public/pm/108.svg';
import filedefault, {
  ReactComponent as JSXdefault,
} from './public/pm/default.svg';

export const paymentImages: ImageMap = {
  1: { path: file1, component: JSX1 },
  10: { path: file10, component: JSX10 },
  11: { path: file11, component: JSX11 },
  12: { path: file12, component: JSX12 },
  13: { path: file13, component: JSX13 },
  14: { path: file14, component: JSX14 },
  15: { path: file15, component: JSX15 },
  16: { path: file16, component: JSX16 },
  17: { path: file17, component: JSX17 },
  18: { path: file18, component: JSX18 },
  19: { path: file19, component: JSX19 },
  2: { path: file2, component: JSX2 },
  20: { path: file20, component: JSX20 },
  21: { path: file21, component: JSX21 },
  22: { path: file22, component: JSX22 },
  23: { path: file23, component: JSX23 },
  24: { path: file24, component: JSX24 },
  25: { path: file25, component: JSX25 },
  26: { path: file26, component: JSX26 },
  27: { path: file27, component: JSX27 },
  28: { path: file28, component: JSX28 },
  29: { path: file29, component: JSX29 },
  3: { path: file3, component: JSX3 },
  30: { path: file30, component: JSX30 },
  31: { path: file31, component: JSX31 },
  32: { path: file32, component: JSX32 },
  33: { path: file33, component: JSX33 },
  34: { path: file34, component: JSX34 },
  35: { path: file35, component: JSX35 },
  37: { path: file37, component: JSX37 },
  38: { path: file38, component: JSX38 },
  39: { path: file39, component: JSX39 },
  4: { path: file4, component: JSX4 },
  40: { path: file40, component: JSX40 },
  41: { path: file41, component: JSX41 },
  42: { path: file42, component: JSX42 },
  43: { path: file43, component: JSX43 },
  44: { path: file44, component: JSX44 },
  45: { path: file45, component: JSX45 },
  46: { path: file46, component: JSX46 },
  47: { path: file47, component: JSX47 },
  48: { path: file48, component: JSX48 },
  49: { path: file49, component: JSX49 },
  5: { path: file5, component: JSX5 },
  50: { path: file50, component: JSX50 },
  51: { path: file51, component: JSX51 },
  52: { path: file52, component: JSX52 },
  53: { path: file53, component: JSX53 },
  54: { path: file54, component: JSX54 },
  6: { path: file6, component: JSX6 },
  7: { path: file7, component: JSX7 },
  8: { path: file8, component: JSX8 },
  9: { path: file9, component: JSX9 },
  88: { path: file88, component: JSX88 },
  89: { path: file89, component: JSX89 },
  90: { path: file90, component: JSX90 },
  91: { path: file91, component: JSX91 },
  92: { path: file92, component: JSX92 },
  93: { path: file93, component: JSX93 },
  94: { path: file94, component: JSX94 },
  95: { path: file95, component: JSX95 },
  101: { path: file101, component: JSX101 },
  102: { path: file102, component: JSX102 },
  103: { path: file103, component: JSX103 },
  106: { path: file106, component: JSX106 },
  107: { path: file107, component: JSX107 },
  104: { path: file104, component: JSX104 },
  96: { path: file96, component: JSX96 },
  97: { path: file97, component: JSX97 },
  98: { path: file98, component: JSX98 },
  99: { path: file99, component: JSX99 },
  100: { path: file100, component: JSX100 },
  108: { path: file108, component: JSX108 },
  default: { path: filedefault, component: JSXdefault },
};
